import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { CustomLabel, Modal, LinkProductsContainer } from "../../styled/setting";
import { TfiSearch } from "react-icons/tfi";
import Search from "../common/search";
import { IoClose } from "react-icons/io5";

const LinkProducts = ({
  selected,
  products = null,
  toggleModal,
  openModal,
  closeModal,
  selectCompany,
  getOptions,
}) => {
  const [data, setData] = useState([]);
  const [searched, setSearched] = useState("");
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    setData(products ? [...products] : []);
    setChecked((selected?.linkedProducts || []).map((product) => product.id));
  }, [products]);

  const searchProduct = (flag = false) => {
    setData(flag ? products : products.filter((ele) => ele.name.includes(searched)));
  };
  const toggleCheck = (id) => {
    if (checked.includes(id)) {
      setChecked((data) => [...data].filter((checked) => id !== checked));
    } else {
      setChecked((data) => [...data, id]);
    }
  };

  const submitLink = async () => {
    const curr = (selected?.linkedProducts || []).map(({ id }) => id);
    const add = checked.filter((id) => !curr.includes(id)).map((id) => Number(id));
    const remove = curr.filter((id) => !checked.includes(id)).map((id) => Number(id));

    try {
      await Promise.all([
        add.length > 0 && linkProducts(add),
        remove.length > 0 && unlinkProducts(remove),
      ]);

      toast.success("상품 연동 상태가 업데이트되었습니다.");
      await getOptions();
      toggleModal();
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  const linkProducts = (vendorProductIds) =>
    axios.post("/erp/link/create", {
      optionGroupId: selected.id,
      vendorProductIds,
      cmpnyNo: selectCompany.value,
    });

  const unlinkProducts = (vendorProductIds) =>
    axios.post("/erp/link/delete", {
      optionGroupId: selected.id,
      vendorProductIds,
      cmpnyNo: selectCompany.value,
    });

  return (
    <Modal onClick={(e) => e.currentTarget === e.target && toggleModal()}>
      <div className="modal">
        <LinkProductsContainer>
          <strong className="label">옵션정보</strong>
          <div className="option">
            <div>
              <span className="tit">옵션그룹명</span>
              <span className="cont">{selected.name}</span>
            </div>
            <div>
              <span className="tit">옵션</span>
              <span className="cont">{selected.options.map((opt) => opt.value).join(", ")}</span>
            </div>
          </div>
          <strong className="label">상품</strong>
          <div className="products">
            <Search
              setSearched={setSearched}
              searched={searched}
              searchEvent={searchProduct}
              placeholder="상품명을 입력해주세요"
            />
            <ul>
              {data && data.length > 0 ? (
                data.map((item) => (
                  <li>
                    <CustomLabel>
                      <input
                        type="checkbox"
                        checked={checked.includes(item.id)}
                        onChange={(e) => toggleCheck(item.id)}
                      />
                      <div className="checkmark"></div>
                    </CustomLabel>
                    <img
                      src={
                        item.media && item.media.length > 0
                          ? imgHandler(item.media)
                          : "/img/icon_function_4.png"
                      }
                      alt={item.name}
                      onError={(e) => (e.target.src = "/img/icon_function_4.png")}
                    />
                    <div className="productInfo">
                      <span className="name">상품코드 {item.cloudProduct.id}</span>
                      <span>{item.name}</span>
                      <span>{formatNumber(item.price)}원</span>
                    </div>
                  </li>
                ))
              ) : (
                <li className="not">메뉴가 존재하지 않습니다.</li>
              )}
            </ul>
          </div>
          <div>
            <button
              className="submit"
              onClick={() =>
                openModal({
                  type: "confirmation",
                  title: "상품 연동",
                  message: [`변경하신 내용을 저장하시겠습니까?`],
                  handleConfirm: () => submitLink(),
                })
              }>
              저장
            </button>
          </div>
          <button className="closeModal" onClick={() => toggleModal()}>
            <IoClose />
          </button>
        </LinkProductsContainer>
      </div>
    </Modal>
  );
};

export default LinkProducts;
